import * as yup from "yup";

const newlyUpdateSchema = yup.object().shape({
  update: yup.string(),
  updatedBy: yup.string(),
  updateDate: yup.string(),
});

const subFeatureSchema = yup.object().shape({
  feature: yup.string(),
  description: yup.string(),
  accessRoute: yup.string(),
  accessRoles: yup.array().of(yup.string()),
  createdBy: yup.string(),
  date: yup.string(),
});

export const FeatureSchema = yup.object().shape({
  feature: yup.string().required("Feature is required"),
  description: yup.string(),
  accessRoute: yup.string(),
  accessRoles: yup.array().of(yup.string()),
  status: yup.string(),
  notes: yup.string(),
  conditions: yup.string(),
  designBy: yup.string(),
  developBy: yup.string(),
  backendBy: yup.string(),
  newlyUpdates: yup.array().of(newlyUpdateSchema),
  subFeature: yup.array().of(subFeatureSchema),
});
